__turbopack_context__.v({
  "root": "CollectionAnimatedSection-module__JxEcEa__root",
});
